/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import Particles from "particles.vue";
import axios from 'axios';
import VueAxios from 'vue-axios';
import {CarouselPlugin} from 'bootstrap-vue'
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDcQjYjF5i4r5TGyzbDbEk7fbyJJmuAkzE",
  authDomain: "corner-dev-14734.firebaseapp.com",
  projectId: "corner-dev-14734",
  storageBucket: "corner-dev-14734.appspot.com",
  messagingSenderId: "1008348566706",
  appId: "1:1008348566706:web:a98c784cf1856e7813a5ab",
  measurementId: "G-2PQPHT46S3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

Vue.config.productionTip = false;

Vue.use(Argon);
Vue.use(Particles);
Vue.use(VueAxios, axios);
Vue.use(CarouselPlugin);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");